import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { queue, type Lead } from '../data/mockData';
export type NewLeadInput = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};
type LeadsContextValue = {
  leads: Lead[];
  addLead: (input: NewLeadInput) => Lead;
};
const LeadsContext = createContext<LeadsContextValue | null>(null);
export function LeadsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [leads, setLeads] = useState<Lead[]>(queue);
  const addLead = useCallback((input: NewLeadInput) => {
    const lead: Lead = {
      id: `l-${Date.now()}`,
      name: `${input.firstName.trim()} ${input.lastName.trim()}`.trim(),
      state: '—',
      amount: 0,
      detail: 'Manually added — call to qualify',
      stage: 'New',
      accent: 'blue',
      source: 'Manual entry',
      phone: input.phone.trim(),
      email: input.email.trim(),
      loanPurpose: 'Not yet captured',
      lastTouch: 'Never contacted',
      attempts: '0 of 6 attempts',
      tasks: [{
        id: `t-${Date.now()}`,
        label: 'First call — qualify lead',
        due: 'Now',
        done: false
      }]
    };
    setLeads(prev => [lead, ...prev]);
    return lead;
  }, []);
  const value = useMemo(() => ({
    leads,
    addLead
  }), [leads, addLead]);
  return <LeadsContext.Provider value={value} data-id="element-254" data-mp="3mtd9ueg4zotr">{children}</LeadsContext.Provider>;
}
export function useLeads(): LeadsContextValue {
  const context = useContext(LeadsContext);
  if (!context) {
    throw new Error('useLeads must be used within a LeadsProvider');
  }
  return context;
}